export  function changeTitlePage(title) {
    var titleElement = document.querySelector("#page-title");
    titleElement.textContent = title;
}

export default changeTitlePage;